import { memo, useCallback, useState } from 'react';
import { ModalsContext } from './ModalsContext';
import { IChildrenProps } from 'interfaces/general.interface';

const ModalsProvider = ({ children }: IChildrenProps) => {
  const [showAssociationModal, setShowAssociationModalAction] = useState(false);

  const setShowAssociationModal = useCallback((isOpen: boolean) => {
    setShowAssociationModalAction(isOpen);
  }, []);

  return (
    <ModalsContext.Provider
      value={{
        showAssociationModal,
        setShowAssociationModal,
      }}
    >
      {children}
    </ModalsContext.Provider>
  );
};

export default memo(ModalsProvider);
